/* =============================================
   PELSBARN THEME — theme.js
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ---- MOBILE NAV ----
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
  }

  // ---- ACCORDIONS ----
  document.querySelectorAll('.accordion__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const isOpen = body.classList.contains('is-open');
      btn.classList.toggle('is-open', !isOpen);
      body.classList.toggle('is-open', !isOpen);
    });
  });

  // ---- GALLERY ----
  const mainImg = document.getElementById('gallery-main-img');
  const thumbs  = document.querySelectorAll('.gallery__thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (src) mainImg.src = src;
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // ---- VARIANT SELECTOR ----
  initVariantSelector();

  // ---- HELPERS ----
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // ---- CART DRAWER ELEMENTS ----
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');
  const drawerBody  = document.querySelector('.cart-drawer__body');
  const drawerFoot  = document.querySelector('.cart-drawer__footer');

  // ---- OPEN / CLOSE ----
  function openCart() {
    if (cartDrawer)  cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer)  cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Cart icon button — open drawer and refresh contents
  document.querySelectorAll('[data-open-cart]').forEach(el => {
    el.addEventListener('click', async () => {
      openCart();
      await renderCart();
    });
  });

  // ---- CART COUNT ----
  async function refreshCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch(e) {}
  }
  refreshCartCount();

  // ---- RENDER CART DRAWER ----
  // Single authoritative function — fetches fresh cart state and renders it
  async function renderCart() {
    if (!drawerBody) return;

    // Show loading state so user knows something is happening
    drawerBody.innerHTML = '<div style="padding:40px;text-align:center;color:var(--muted)">Loading…</div>';
    if (drawerFoot) drawerFoot.innerHTML = '';

    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      // Update count badge at same time
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Empty cart
      if (cart.item_count === 0) {
        drawerBody.innerHTML = '<div class="cart-empty" style="text-align:center;padding:40px 0;color:var(--muted)"><p>Your cart is empty.</p></div>';
        return;
      }

      // Group by variant_id (Shopify splits BOGO into multiple line items)
      const seenVariants = new Set();
      const variantSummary = {};
      cart.items.forEach(item => {
        const vid = String(item.variant_id);
        if (!variantSummary[vid]) {
          variantSummary[vid] = {
            variantId: vid,
            product_title: item.product_title,
            variant_title: item.variant_title,
            image: item.image,
            totalQty: 0,
            maxUnitPrice: 0
          };
        }
        variantSummary[vid].totalQty += item.quantity;
        if (item.final_price > variantSummary[vid].maxUnitPrice) {
          variantSummary[vid].maxUnitPrice = item.final_price;
        }
      });

      // Build HTML — one paid row + one FREE row per unique variant
      const itemsHtml = Object.values(variantSummary).map(v => {
        const variantLabel = (v.variant_title && v.variant_title !== 'Default Title')
          ? `<div style="font-size:12px;color:var(--muted);margin-top:2px">${v.variant_title}</div>`
          : '';

        const isBogo = v.totalQty >= 2;

        const paidRow = `
          <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid var(--border)">
            <img src="${v.image}" alt="${v.product_title}"
              style="width:64px;height:64px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#eef2fb">
            <div style="flex:1;min-width:0">
              <div style="font-size:13px;font-weight:700;line-height:1.3">${v.product_title}</div>
              ${variantLabel}
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">
                <div style="font-size:14px;font-weight:700">${formatMoney(v.maxUnitPrice)}</div>
                <button class="remove-btn" data-variant-id="${v.variantId}"
                  style="background:none;border:none;font-size:12px;color:var(--red);cursor:pointer;font-weight:600;padding:4px 6px;border-radius:4px">
                  Remove
                </button>
              </div>
            </div>
          </div>`;

        const freeRow = isBogo ? `
          <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid var(--border);background:#f0fdf4;margin:0 -24px;padding-left:24px;padding-right:24px">
            <img src="${v.image}" alt="${v.product_title}"
              style="width:64px;height:64px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#eef2fb;opacity:0.85">
            <div style="flex:1;min-width:0">
              <div style="display:flex;align-items:center;gap:6px;margin-bottom:3px;flex-wrap:wrap">
                <div style="font-size:13px;font-weight:700;line-height:1.3">${v.product_title}</div>
                <span style="background:#3a9668;color:#fff;font-size:10px;font-weight:800;padding:2px 7px;border-radius:20px;white-space:nowrap">FREE 🎁</span>
              </div>
              ${variantLabel}
              <div style="font-size:13px;font-weight:700;color:#3a9668;margin-top:6px">
                $0.00 <span style="font-size:11px;font-weight:400;color:var(--muted)">— discount applied at checkout</span>
              </div>
            </div>
          </div>` : '';

        return paidRow + freeRow;
      }).join('');

      // Write everything to DOM at once
      drawerBody.innerHTML = itemsHtml;

      if (drawerFoot) {
        drawerFoot.innerHTML = `
          <div style="display:flex;justify-content:space-between;font-weight:700;margin-bottom:14px;font-size:15px">
            <span>Subtotal</span>
            <span>${formatMoney(cart.total_price)}</span>
          </div>
          <a href="/checkout" class="btn btn--primary btn--full"
            style="text-decoration:none;display:flex;align-items:center;justify-content:center;font-size:16px">
            Checkout →
          </a>
          <a href="/cart"
            style="display:block;text-align:center;font-size:13px;color:var(--muted);margin-top:10px;text-decoration:underline">
            View full cart
          </a>`;
      }

      // Wire remove buttons — remove ALL line items with the same variant_id
      drawerBody.querySelectorAll('.remove-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const variantId = btn.dataset.variantId;
          btn.textContent = '…';
          btn.disabled = true;

          try {
            // Get fresh cart and find all keys matching this variant
            const r1 = await fetch('/cart.js');
            const c1 = await r1.json();
            const keysToRemove = c1.items
              .filter(i => String(i.variant_id) === String(variantId))
              .map(i => i.key);

            // Remove each line-item sequentially
            for (const key of keysToRemove) {
              const r = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              });
              await r.json();
            }

            // Wait for Shopify to recalculate BOGO across remaining variants
            await wait(500);
            await renderCart();
          } catch(e) {
            btn.textContent = 'Remove';
            btn.disabled = false;
          }
        });
      });

    } catch(e) {
      drawerBody.innerHTML = '<div style="padding:20px;text-align:center;color:var(--muted)">Could not load cart. Please refresh.</div>';
    }
  }

  // ---- ADD TO CART (BOGO — always qty 2 per variant) ----
  const atcBtn = document.getElementById('atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = document.getElementById('selected-variant-id')?.value;
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      try {
        // Get current cart state — sum quantities across all lines for this variant
        const cartRes = await fetch('/cart.js');
        const cart    = await cartRes.json();
        const existingLines = cart.items.filter(i => String(i.variant_id) === String(variantId));
        const totalQty = existingLines.reduce((sum, line) => sum + line.quantity, 0);

        if (totalQty === 0) {
          // Not in cart — add qty 2
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 2 })
          });
          await r.json();
        } else if (totalQty < 2) {
          // Has 1 unit only (somehow) — add 1 more
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: (2 - totalQty) })
          });
          await r.json();
        }
        // If totalQty already >= 2, do nothing — BOGO already satisfied

        // Wait for Shopify to settle, then render cart and open drawer
        await wait(300);
        await renderCart();  // renders fresh cart including FREE row
        openCart();          // open AFTER content is ready

        atcBtn.textContent = '✓ Added!';

      } catch (err) {
        console.error('ATC error:', err);
        atcBtn.textContent = 'Error — try again';
      }

      await wait(2000);
      atcBtn.disabled = false;
      atcBtn.textContent = atcBtn.dataset.defaultText || 'Add to Cart';
    });
  }

  // Load cart count on page load
  refreshCartCount();

});

// ---- VARIANT SELECTOR LOGIC ----
function initVariantSelector() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantInput = document.getElementById('selected-variant-id');
  const priceEl      = document.getElementById('product-price');
  const compareEl    = document.getElementById('product-price-compare');
  const savingsBadge = document.getElementById('product-savings-badge');
  const atcBtn       = document.getElementById('atc-btn');

  const variantsJson = document.getElementById('product-variants-json');
  if (!variantsJson) return;
  const variants = JSON.parse(variantsJson.textContent);

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedOptions() {
    const options = {};
    form.querySelectorAll('.size-opt.is-active').forEach(el => {
      options[el.dataset.optionIndex] = el.dataset.value;
    });
    form.querySelectorAll('.color-opt.is-active').forEach(el => {
      options[el.dataset.optionIndex] = el.dataset.value;
    });
    return options;
  }

  function findVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => options[String(i)] === opt)
    );
  }

  function updateVariant() {
    const options = getSelectedOptions();
    const variant = findVariant(options);
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = 'inline';
        if (savingsBadge) {
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          savingsBadge.textContent = 'Save ' + pct + '%';
          savingsBadge.style.display = 'inline-flex';
        }
      } else {
        compareEl.style.display = 'none';
        if (savingsBadge) savingsBadge.style.display = 'none';
      }
    }

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart — ' + formatMoney(variant.price);
        atcBtn.dataset.defaultText = 'Add to Cart — ' + formatMoney(variant.price);
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
  }

  form.querySelectorAll('.size-opt').forEach(btn => {
    btn.addEventListener('click', () => {
      const index = btn.dataset.optionIndex;
      form.querySelectorAll(`.size-opt[data-option-index="${index}"]`).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const labelEl = document.querySelector(`[data-option-label="${index}"]`);
      if (labelEl) labelEl.textContent = btn.dataset.value;
      updateVariant();
    });
  });

  form.querySelectorAll('.color-opt').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const index = swatch.dataset.optionIndex;
      form.querySelectorAll(`.color-opt[data-option-index="${index}"]`).forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      const labelEl = document.querySelector(`[data-option-label="${index}"]`);
      if (labelEl) labelEl.textContent = swatch.dataset.value;
      updateVariant();
    });
  });

  updateVariant();
}